module.exports = __webpack_public_path__ + "static/media/400038_02.aebc28ba.png";